import React from 'react';
import { Dialog, DialogContent, Button } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Title, Subtitle, ButtonGroup, warningIcon, acceptButton, cancelButton } from './style';

function ConfirmationModal({ open, close, onAccept, isDraft }) {
  const { t2 } = useTranslation('EditCoursePost');

  const handleAccept = () => {
    close();
    onAccept();
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogContent style={{ textAlign: 'center', justifyContent: 'space-between' }}>
        <ReportGmailerrorredIcon fontSize="large" style={warningIcon} />
        <Title>{isDraft ? t2('DialogTitleDraft') : t2('DialogTitlePublish')}</Title>
        <Subtitle>{isDraft ? t2('DialogSubtitleDraft') : t2('DialogSubtitlePublish')}</Subtitle>
        <ButtonGroup>
          <Button variant="contained" onClick={close} sx={cancelButton}>
            {t2('Cancel')}
          </Button>
          <Button variant="contained" onClick={handleAccept} style={acceptButton}>
            {t2('Confirm')}
          </Button>
        </ButtonGroup>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmationModal;
